import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


import { QrCargaMensaje } from "./model";

export interface Props {
    mensaje: QrCargaMensaje | undefined;
    onLectura: (x: string) => void | Promise<void>;
    onClose: () => void;
}


const style: React.CSSProperties =
    {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10000,
        position: "fixed",
        background: "black",
        display: "flex",
        flexDirection: "column"
    };

export interface State {
    cargando: boolean;
    ultimoMensaje: string;
    color: "rojo" | "verde" | "gris";
    conteoLectura: number;
}

class LectorQRCargaDescargaNoRx extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            cargando: false,
            ultimoMensaje: "",
            color: "gris",
            conteoLectura: 0
        };
    }
    onLectura = async (x: string) => {
        await new Promise(resolve => this.setState({ cargando: true }, resolve));
        const success = await kea.execUserFunc(async () => {
            await this.props.onLectura(x);
        })

        const conteoLectura = this.state.conteoLectura + 1;
        await new Promise(resolve => this.setState({ cargando: false, color: success ? "verde" : "rojo", conteoLectura: conteoLectura }, resolve));

        
        setTimeout(() => this.setState(prev =>
            prev.conteoLectura == conteoLectura ? { color: "gris" } : { color: prev.color }),
            3000
        );

    }

    render() {
        const mensaje = this.props.mensaje || {
                camion: "",
                cantGuias: 0,
                cantServiciosIncompletos: 0,
                ruta: "",
                ultimoEscaneo: null
        };

        const colorStatus =
            this.state.color == "verde" ? "#2C6200" :
                this.state.color == "rojo" ? "#7D000C" :
                    "#282828";

        return (
            <div style={style}>
                <div style={{ flex: "0 1 0", color: "white", background: "#07154A" }}>
                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                        <div style={{ flex: "1 0 0" }} />
                        <span style={{ flex: "0 1 auto" }}>
                            <i className="fa fa-qrcode fa-fw" />
                            <label style={{ color: "white" }} >Escaneo de etiquetas</label>
                        </span>

                        <div style={{ flex: "1 0 0" }} />
                        <div style={{ flex: "0 1 auto" }}>
                            <kea.Button style="danger"  onClick={() => this.props.onClose()}>
                                Cerrar
                            </kea.Button>
                        </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", background: "#62001E", fontSize: "14px" }}>
                        <div style={{ flex: "1 0 0" }} >
                            <label>Contenedor:</label>
                            {mensaje.camion}
                        </div>

                        <div style={{ flex: "1 0 0" }} >
                            <label>Ruta:</label>
                            {mensaje.ruta}
                        </div>

                        <div style={{ flex: "1 0 0" }} >
                            <label>Cant. guias:</label>
                            {mensaje.cantGuias}
                        </div>
                        <div style={{ flex: "1 0 0" }} >
                            <label>Cant. serv. incomp.:</label>
                            {mensaje.cantServiciosIncompletos}
                        </div>
                    </div>

                    {
                        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", background: colorStatus, fontSize: "14px" }}>
                            <div style={{ flex: "1 0 0" }} >
                                <label>Ult. lectura:</label>
                            </div>

                            <div style={{ flex: "1 0 0" }} >
                                {mensaje.ultimoEscaneo && mensaje.ultimoEscaneo.tipo}
                            </div>

                            <div style={{ flex: "1 0 0" }} >
                                {mensaje.ultimoEscaneo && mensaje.ultimoEscaneo.guia}
                            </div>
                            <div style={{ flex: "1 0 0" }} >
                                {mensaje.ultimoEscaneo && (
                                    mensaje.ultimoEscaneo.numeroFisico + " / " + 
                                    mensaje.ultimoEscaneo.totalNumerosFisicos
                                )}
                            </div>
                            
                        </div>
                    }
                </div>

                <div style={{ display: this.state.cargando ?  "flex" : "none", alignItems: "center", background: "Black" }}>
                        <h1>{this.state.ultimoMensaje}</h1>
                        <div className="modal-dialog" style={{ textAlign: "center" }}  >
                        <h1>Validando Código..</h1>
                        <img src="app/img/loading.gif" style={{ maxWidth: "100%" }} />
                        </div>
                </div>

                    <kea.QRReader onChange={x => this.onLectura(x)} style={{
                        flex: "1 0 0",
                        display: this.state.cargando ?  "none" : "flex"
                    }} />
                
                

                
            </div>
        );
    }
}

export const LectorQRCargaDescarga = componentToRx(LectorQRCargaDescargaNoRx);


// WEBPACK FOOTER //
// ./app/features/componentes/cargas/qrCarga/view.tsx